import FetchFactory from "vuex-fetch-factory";
import { StateInterface } from "./state";
import { ProjectRaw, ProjectModel } from "../models";
import {
  getProjectsForCurrentUser,
  getSubscriptionsForCurrentUser,
  getProjectByID,
  getProjectFileOverview,
} from "../api";
import {
  setProjectHandle,
  setProjectsHandle,
  setSubscriptionsHandle,
  setFileEntriesProjectHandle,
} from "./mutations";
import { FileEntryModel, FileEntryRaw } from "../models/fileEntry";

const factory = new FetchFactory<StateInterface, unknown>();

export default {
  fetchProjects: factory.createBulkFetcher<unknown, ProjectRaw, ProjectModel>(
    true,
    setProjectsHandle,
    getProjectsForCurrentUser,
    (): ProjectModel => new ProjectModel()
  ),
  fetchSubscriptions: factory.createBulkFetcher<
    unknown,
    ProjectRaw,
    ProjectModel
  >(
    true,
    setSubscriptionsHandle,
    getSubscriptionsForCurrentUser,
    (): ProjectModel => new ProjectModel()
  ),
  fetchProject: factory.createSingleFetcher<number, ProjectRaw, ProjectModel>(
    true,
    setProjectHandle,
    getProjectByID,
    (): ProjectModel => new ProjectModel()
  ),
  fetchFileEntriesForProject: factory.createBulkFetcher<
    number,
    FileEntryRaw,
    FileEntryModel
  >(
    true,
    setFileEntriesProjectHandle,
    getProjectFileOverview,
    (): FileEntryModel => new FileEntryModel()
  ),
};
